import * as React from 'react';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { CalendarPrintDialog } from 'owa-calendar-surface-print';
import { getCalendarEventColorScheme } from 'owa-calendar-color-resolver';
import { getCalendarFolderId, updateModuleCommand } from 'owa-publishedcalendar-settings';
import { getCharm, getPublishedCalendar } from '../utils/calendarUtils';
import { getSurfaceStore } from '../store/publishedCalendarSurfaceStore';
import { Modal } from '@fluentui/react/lib/Modal';
import { observer } from 'mobx-react-lite';
import { WeekLayout } from 'owa-calendar-surface-print/lib/components';

let styles = require('./PrintDialogRenderer.scss');

/**
 * Calendar print dialog renderer
 */
export default observer(function PrintDialogRenderer() {
    const surfaceStore = getSurfaceStore();
    const calendarId = getCalendarFolderId();

    // Anonymous calendar doesn't track work hours
    const fromHour = 0;
    const toHour = 24;

    const printSettings = {
        agenda: false,
        calendarId: calendarId,
        fromHour: fromHour,
        miniMonth: true,
        notes: false,
        toHour: toHour,
        view: surfaceStore.dateRangeType,
        weekLayout: WeekLayout.Standard,
        // WorkWeekView isn't supported by anonymous calendar. In addition, a related authenticated service request (to check isEdu) would break anonymous calendar.
        hideWorkWeekView: true,
    };

    /* always use one day in published calendar print scenarios since we cannot make calls to the server in annonymous calendar
     * scenarios. Once there is a publishedCalendarSurfaceStore value for numDaysInDayRang, use that here
     * VSO 80763
     */
    const numDaysInDayRange = 1;

    return (
        <Modal
            containerClassName={styles.printDialog}
            isOpen={true}
            onDismiss={onDismissPrintDialog}
            isBlocking={false}>
            <CalendarPrintDialog
                printSettings={printSettings}
                calendars={getPublishedCalendar()}
                getSurfaceItemModel={getSurfaceItemModel}
                date={surfaceStore.selectedDate}
                firstDayOfWeek={surfaceStore.userOptions.weekStartDay}
                showWeekNumbers={false}
                firstWeekOfYear={surfaceStore.userOptions.firstWeekOfYear}
                workWeekDays={surfaceStore.userOptions.workDays}
                getCalendarEventColorScheme={getCalendarEventColorScheme}
                getCharm={getCharm}
                dimissPrintDialog={onDismissPrintDialog}
                getDetailedEvent={getDetailedEvent}
                numDaysInDayRange={numDaysInDayRange}
                isRTL={surfaceStore.userOptions.isRTL}
            />
        </Modal>
    );
});

/**
 * Fetch the event details
 */
async function getDetailedEvent(partialEvent) {
    // TODO: VSO.59359 - when merging getItemDetails PR, will update it here to return the detailed event
    return partialEvent;
}

/**
 * Execute when the print dialog is dismissed
 */
function onDismissPrintDialog() {
    updateModuleCommand(null);
}

/**
 * Return event as CalendarEvent
 */
function getSurfaceItemModel(event) {
    return event as CalendarEvent;
}
